import { useCookieConsentStore } from 'hooks/stores/useCookieConsentStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { analyticsEnabled, identifyUser } from 'utils/analytics/analytics';

import AdtractionTag from './AdtractionTag';
import AffiliateFutureTag from './AffiliateFutureTag';
import AwinTag from './AwinTag';
import { ConvertScript } from './Convert';
import FacebookPixel from './FacebookPixel';
import GoogleAdsScript from './GoogleAdsScript';
import GoogleTagManagerScript from './GoogleTagManagerScript';
import HeadAiScript from './HeadAi';
import HotJarScript from './HotJarScript';
import NextdoorPixel from './NextdoorPixel';
import OrganisationSchema from './OrganisationSchema';
import PinterestPixel from './PinterestPixel';
import PodscribePixel from './PodscribePixel';
import RedditPixel from './RedditPixel';
import SendinblueScript from './SendinblueScript';
import SnapChatPixel from './SnapChatPixel';
import TaboolaPixel from './TaboolaPixel';
import TikTokPixel from './TikTokPixel';
import TripHuntersRedirectScript from './TripHuntersRedirectScript';
import TwitterPixel from './TwitterPixel';
import WebsiteSchema from './WebsiteSchema';
import ZendeskChatBot from './ZendeskChatBot';

const ScriptLayer = observer(() => {
  const { marketingCookiesConsent, analyticsCookiesConsent } =
    useCookieConsentStore();
  const { currentUser } = useUserStore();

  useEffect(() => {
    identifyUser({
      emailAddress: currentUser?.emailAddress,
      id: currentUser?.id,
      firstName: currentUser?.firstName,
      lastName: currentUser?.firstName,
    });
  }, [marketingCookiesConsent, analyticsCookiesConsent, currentUser?.id]);

  return (
    <>
      <TripHuntersRedirectScript />
      <OrganisationSchema />
      <WebsiteSchema />
      <ConvertScript />
      <ZendeskChatBot />

      {analyticsEnabled() && marketingCookiesConsent && (
        <>
          <FacebookPixel />
          <GoogleAdsScript />
          <AffiliateFutureTag />
          <AdtractionTag />
          <AwinTag />
          <SnapChatPixel />
          <SendinblueScript
            optionalEmailAddress={currentUser?.emailAddress || ''}
          />
          <PinterestPixel />
          <TaboolaPixel />
          <TwitterPixel />
          <PodscribePixel />
          <HeadAiScript />
          <TikTokPixel />
          <NextdoorPixel />
          <RedditPixel />
        </>
      )}

      {analyticsEnabled() && analyticsCookiesConsent && (
        <>
          <GoogleTagManagerScript />
          <HotJarScript />
        </>
      )}
    </>
  );
});

export default ScriptLayer;
